module.exports = __webpack_public_path__ + "static/media/folder-icon.2b7380a0.png";